import { render } from "./RouteCodeApiModelHistory.vue?vue&type=template&id=4e9e84f0"
import script from "./RouteCodeApiModelHistory.vue?vue&type=script&lang=js"
export * from "./RouteCodeApiModelHistory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__